import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const match849EmailStep = defineStepConfig({
  type: "match_849_email",
  name: "Match 849 Email",
  description:
    "For an inbound EMAIL 849 response, run the email-matching agent (deterministic " +
    "first, LLM fallback) to interpret the email into structured intent, then apply the " +
    "VDM-anchored reconcile + validate-against-claimed guard. Gated by the per-supplier " +
    "sd_849_email_matching_enabled toggle. Accepts only batches that reconcile; abstains " +
    "(flags) on mismatch. Skips silently for EDI sources or when disabled.",
  category: "AI & Agents",
  libraryModule: "ShipAndDebit",

  inputSchema: z.object({
    sd849ResponseId: z
      .string()
      .nullable()
      .describe(
        "ID of the SD849Response (email source) to match (null if skipped)",
      ),
  }),

  outputSchema: z.object({
    matched: z
      .boolean()
      .describe("Whether the matching agent ran and applied results"),
    skippedReason: z
      .string()
      .nullable()
      .describe("Why matching was skipped (null if it ran)"),
    acceptedLineCount: z
      .number()
      .describe("844 lines accepted via reconciled zero-variance batches"),
    abstainedBatchCount: z
      .number()
      .describe("Batches that did not reconcile and were flagged for review"),
    summary: z
      .string()
      .nullable()
      .describe("Agent reasoning summary (null if skipped)"),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "5 minutes",
    nonRetryableErrorTypes: [
      "WorkflowGuardrailBlockedError",
      "WorkflowGuardrailReviewRequiredError",
    ],
  },
});
